"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _TwilioWhatsappPlugin = /*#__PURE__*/ _interop_require_default(require("./TwilioWhatsappPlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _TwilioWhatsappPlugin.default,
    id: 'twilio-whatsapp',
    title: 'Whatsapp Twilio',
    version: '0.0.1',
    logo: 'plugins/whatsapp.png',
    description: 'With Twilio, unite communications and strengthen customer relationships across your business – from marketing and sales to customer service and operations.',
    price: 'Free',
    tags: 'Chat',
    category: 'Twilio',
    inputs: {
        title: 'Configure Twilio',
        items: [
            {
                key: 'sid',
                label: 'Account SID',
                placeholder: 'Account SID',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'token',
                label: 'Auth Token',
                placeholder: 'Auth Token',
                type: _nocodbsdk.XcType.Password,
                required: true
            },
            {
                key: 'from',
                label: 'From Phone Number',
                placeholder: 'From Phone Number',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully installed and Whatsapp Twilio is enabled for notification.',
        msgOnUninstall: ''
    }
};
const _default = config;
